// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3OCSw","inner":"Form_inner__Xb5R7","range":"Form_range__Wkpua","name":"Form_name__3kfQo","actions":"Form_actions__3W8rD"};